export function stringLengthHelper(string: string, length?: number) {
    try {
        return (string.length > (length ? length : 15)) ? `${string.substring(0, length ? length - 1 : 14)}...` : string
    } catch (e) {
        return '';
    }
}